import React from "react";

export const BigIcons = ({
  size = 24,
  fill = "#292D32",
  callBack = () => {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={callBack}
      width={size}
      height={size}
      className="pointer"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.5 5.05859V18.9386C3.5 19.3486 3.16 19.6886 2.75 19.6886C2.34 19.6886 2 19.3486 2 18.9386V5.05859C2 4.64859 2.34 4.30859 2.75 4.30859C3.16 4.30859 3.5 4.64859 3.5 5.05859Z"
        fill={fill}
      />
      <path
        d="M22 5.05859V18.9386C22 19.3486 21.66 19.6886 21.25 19.6886C20.84 19.6886 20.5 19.3486 20.5 18.9386V5.05859C20.5 4.64859 20.84 4.30859 21.25 4.30859C21.66 4.30859 22 4.64859 22 5.05859Z"
        fill={fill}
      />
      <path
        d="M8 21.25H16C17.66 21.25 19 19.91 19 18.25V5.75C19 4.09 17.66 2.75 16 2.75H8C6.34 2.75 5 4.09 5 5.75V18.25C5 19.91 6.34 21.25 8 21.25Z"
        fill={fill}
      />
    </svg>
  );
};

export const MediumIcons = ({
  size = 24,
  fill = "#292D32",
  callBack = () => {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={callBack}
      width={size}
      height={size}
      className="pointer"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.25 12.75V22H7.81C4.17 22 2 19.83 2 16.19V12.75H11.25Z"
        fill={fill}
      />
      <path
        d="M22 7.81V11.25H12.75V2H16.19C19.83 2 22 4.17 22 7.81Z"
        fill={fill}
      />
      <path d="M11.25 2V11.25H2V7.81C2 4.17 4.17 2 7.81 2H11.25Z" fill={fill} />
      <path
        d="M22 12.75V16.19C22 19.83 19.83 22 16.19 22H12.75V12.75H22Z"
        fill={fill}
      />
    </svg>
  );
};
export const SmallIcons = ({
  size = 24,
  fill = "#292D32",
  callBack = () => {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={callBack}
      width={size}
      height={size}
      className="pointer"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M7.75 2V7.8H2C2 4.19 4.15 2.02 7.75 2Z" fill={fill} />
      <path d="M22 7.8H16.25V2C19.85 2.02 22 4.19 22 7.8Z" fill={fill} />
      <path
        d="M22 16.3008C21.96 19.8508 19.82 21.9808 16.25 22.0008V16.3008H22Z"
        fill={fill}
      />
      <path
        d="M7.75 16.3008V22.0008C4.18 21.9808 2.04 19.8508 2 16.3008H7.75Z"
        fill={fill}
      />
      <path d="M7.75 9.30078H2V14.8008H7.75V9.30078Z" fill={fill} />
      <path d="M22 9.30078H16.25V14.8008H22V9.30078Z" fill={fill} />
      <path d="M14.75 9.30078H9.25V14.8008H14.75V9.30078Z" fill={fill} />
      <path d="M14.75 2H9.25V7.8H14.75V2Z" fill={fill} />
      <path d="M14.75 16.3008H9.25V22.0008H14.75V16.3008Z" fill={fill} />
    </svg>
  );
};

export const ListIcons = ({
  size = 24,
  fill = "#292D32",
  callBack = () => {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={callBack}
      width={size}
      height={size}
      className="pointer"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.9994 19.2611H10.9294C10.4794 19.2611 10.1094 18.8911 10.1094 18.4411C10.1094 17.9911 10.4794 17.6211 10.9294 17.6211H19.9994C20.4494 17.6211 20.8194 17.9911 20.8194 18.4411C20.8194 18.9011 20.4494 19.2611 19.9994 19.2611Z"
        fill={fill}
      />
      <path
        d="M19.9994 12.9681H10.9294C10.4794 12.9681 10.1094 12.5981 10.1094 12.1481C10.1094 11.6981 10.4794 11.3281 10.9294 11.3281H19.9994C20.4494 11.3281 20.8194 11.6981 20.8194 12.1481C20.8194 12.5981 20.4494 12.9681 19.9994 12.9681Z"
        fill={fill}
      />
      <path
        d="M19.9994 6.67125H10.9294C10.4794 6.67125 10.1094 6.30125 10.1094 5.85125C10.1094 5.40125 10.4794 5.03125 10.9294 5.03125H19.9994C20.4494 5.03125 20.8194 5.40125 20.8194 5.85125C20.8194 6.30125 20.4494 6.67125 19.9994 6.67125Z"
        fill={fill}
      />
      <path
        d="M4.90969 8.03187C4.68969 8.03187 4.47969 7.94187 4.32969 7.79187L3.41969 6.88188C3.09969 6.56188 3.09969 6.04187 3.41969 5.72187C3.73969 5.40187 4.25969 5.40187 4.57969 5.72187L4.90969 6.05188L7.04969 3.91187C7.36969 3.59188 7.88969 3.59188 8.20969 3.91187C8.52969 4.23188 8.52969 4.75188 8.20969 5.07188L5.48969 7.79187C5.32969 7.94187 5.12969 8.03187 4.90969 8.03187Z"
        fill={fill}
      />
      <path
        d="M4.90969 14.3287C4.69969 14.3287 4.48969 14.2487 4.32969 14.0887L3.41969 13.1788C3.09969 12.8588 3.09969 12.3388 3.41969 12.0188C3.73969 11.6988 4.25969 11.6988 4.57969 12.0188L4.90969 12.3488L7.04969 10.2087C7.36969 9.88875 7.88969 9.88875 8.20969 10.2087C8.52969 10.5288 8.52969 11.0487 8.20969 11.3687L5.48969 14.0887C5.32969 14.2487 5.11969 14.3287 4.90969 14.3287Z"
        fill={fill}
      />
      <path
        d="M4.90969 20.3288C4.69969 20.3288 4.48969 20.2488 4.32969 20.0888L3.41969 19.1788C3.09969 18.8588 3.09969 18.3388 3.41969 18.0188C3.73969 17.6988 4.25969 17.6988 4.57969 18.0188L4.90969 18.3488L7.04969 16.2087C7.36969 15.8888 7.88969 15.8888 8.20969 16.2087C8.52969 16.5288 8.52969 17.0488 8.20969 17.3688L5.48969 20.0888C5.32969 20.2488 5.11969 20.3288 4.90969 20.3288Z"
        fill={fill}
      />
    </svg>
  );
};
